import { Link, Stack, Text } from "@seneca/senekit";

import { linkToUnblockSchoolNetworkArticle } from "common/links";

import useAppName from "features/common/hooks/useAppName";
import { ROUTES } from "routing/routes";

export default function HelpBulletPoints() {
  const appName = useAppName();

  return (
    <ul>
      <Stack space={["small", "medium"]}>
        <BulletPointItem>
          Make sure you're logged into the <strong>account</strong> and{" "}
          <strong>device</strong> you're experiencing issues with.{" "}
          <Link
            to={ROUTES.DASHBOARD.SETTINGS.PERSONAL_INFORMATION.buildPath({})}
          >
            Check here
          </Link>{" "}
          to ensure you're using the correct login
        </BulletPointItem>

        <BulletPointItem>
          If you are working at school this could be due to your school network
          blocking some of the things {appName} needs to work.{" "}
          <Link to={linkToUnblockSchoolNetworkArticle("en")}>
            Share this link&nbsp;
          </Link>
          with an IT technician at your school to help them fix it
        </BulletPointItem>
      </Stack>
    </ul>
  );
}

function BulletPointItem({ children }: { children: React.ReactNode }) {
  return (
    <li>
      <Text>{children}</Text>
    </li>
  );
}
